const initialState = {
  lang: localStorage.getItem('i18nextLng') || 'en',
};

export default initialState;
